export default [{
    label: 'noissue Eco Alliance',
    key: 'noissue-eco-alliance'
}, {
    label: 'noissuetv',
    key: 'noissuetv'
}, {
    label: 'Conscious Commerce',
    key: 'conscious-commerce'
}];
